/**
 * App version, taken from package.json at build time by vite.config.ts.
 *
 * Bump it with `npm version patch|minor|major` — that updates package.json and
 * (via the `version` script) appPackage/manifest.json in the same commit, so
 * the number shown in the UI always matches the Teams app package.
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "0.0.0";

/** Ready to render, e.g. "v1.0.0". */
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
